import React from 'react';
import styled from 'styled-components';
import { Container, Heading } from '../primitives';
import { tokens } from '../../config/themeTokens';

const Wrapper = styled.section`
  padding: ${tokens.spacing.section} 0;
  background: ${({ $alt }) => ($alt ? tokens.colors.backgroundAlt : tokens.colors.background)};
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: ${tokens.spacing.xl};
  margin-top: ${tokens.spacing.xl};
`;

export function FeatureGridSection({ title, children, alt }) {
  return (
    <Wrapper $alt={alt}>
      <Container>
        {title && <Heading level={2}>{title}</Heading>}
        <Grid>{children}</Grid>
      </Container>
    </Wrapper>
  );
}

export default FeatureGridSection;
